import {
  jb_moment_page_hero_css_default
} from "./chunk.SUBNDKSN.js";
import {
  ScrollTrigger
} from "./chunk.SY5TJF72.js";
import {
  gsapWithCSS
} from "./chunk.MDJ4MKC6.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  isSizeMdDown
} from "./chunk.YDQDJZUC.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  debounce,
  smoothScroll
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i,
  w
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-moment-page-hero/jb-moment-page-hero.ts
var JBMomentPageHero = class extends i {
  constructor() {
    super(...arguments);
    this._animationPlayed = false;
  }
  async firstUpdated() {
    await this.updateComplete;
    gsapWithCSS.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: false });
    this._drawLine();
    window.addEventListener(
      "resize",
      debounce(() => {
        this._drawLine();
      }, 50)
    );
    gsapWithCSS.to(this._headerContent, {
      scrollTrigger: {
        trigger: this._main,
        start: "top bottom",
        end: "+=50%",
        scrub: 0
      },
      yoyo: true,
      opacity: 0,
      scale: 0.8
    });
    gsapWithCSS.to(this, {
      scrollTrigger: {
        trigger: this._main,
        start: "top bottom",
        end: "+=50%",
        scrub: 0
      },
      yoyo: true,
      "--_background-opacity": 0.6
    });
    gsapWithCSS.to(this._headerElement.querySelector("img, jb-video"), {
      scrollTrigger: {
        trigger: this,
        start: "bottom+=100px bottom",
        end: "bottom+=100px top",
        scrub: 0
      },
      translateY: "288px"
    });
    const scrollbutton = this.shadowRoot.querySelector("button");
    gsapWithCSS.fromTo(
      scrollbutton,
      {
        opacity: 0,
        translateY: "-40px"
      },
      {
        opacity: 1,
        translateY: "0",
        duration: 1
      }
    );
    gsapWithCSS.fromTo(
      scrollbutton,
      { opacity: 1 },
      {
        scrollTrigger: {
          trigger: this._main,
          start: "top bottom",
          end: "+=50",
          scrub: 0
        },
        yoyo: true,
        opacity: 0
      }
    );
  }
  _drawLine() {
    if (isSizeMdDown()) return;
    const slotElement = this.shadowRoot.querySelector("slot");
    const slotRect = slotElement.getBoundingClientRect();
    const slotPaddingBottom = parseInt(getComputedStyle(slotElement).marginBlockEnd, 10);
    this._pathString = `M ${slotRect.left - slotRect.width / 8} ${this._headerContent.offsetTop} V ${slotRect.bottom + window.scrollY + slotPaddingBottom}  H ${slotRect.left + slotRect.width / 2} v ${slotPaddingBottom / 2}`;
    this._linepath = this._line.querySelector("path");
    setTimeout(() => {
      this._lineLength = this._linepath.getTotalLength();
      this._linepath.style.strokeDasharray = this._lineLength.toString();
      if (this._animationPlayed) {
        this._linepath.style.strokeDashoffset = this._lineLength - this._headerContent.offsetHeight;
        return;
      }
      this._linepath.style.strokeDashoffset = this._lineLength;
      gsapWithCSS.fromTo(
        this._linepath.style,
        { strokeDashoffset: this._lineLength },
        {
          strokeDashoffset: this._lineLength - this._headerContent.offsetHeight,
          duration: 1,
          onComplete: () => {
            this._animationPlayed = true;
          }
        }
      );
    }, 0);
    ScrollTrigger.create({
      trigger: this,
      start: "top top",
      end: `bottom+=${window.innerHeight * 25 / 100} bottom`,
      endTrigger: this._contactTeaser ?? void 0,
      scrub: 1,
      onUpdate: (self) => {
        const animatedLength = this._lineLength - this._headerContent.offsetHeight;
        if (animatedLength - animatedLength * self.progress <= 0) {
          this._linepath.style.strokeDashoffset = 0;
          return;
        }
        this._linepath.style.strokeDashoffset = animatedLength - animatedLength * self.progress;
      }
    });
  }
  _renderContactTeaser() {
    if (!this.contactTeaser) return A;
    const { headline, subheadline, text, buttons } = this.contactTeaser;
    if (!headline && !subheadline && !text && !buttons?.length) return A;
    return b`
      <div class="contact-teaser">
        ${headline ? b`<jb-heading class="headline">${headline}</jb-heading>` : A}
        ${subheadline ? b`<jb-heading
                class="subheadline"
                offset=${headline ? 1 : 0}
                >${subheadline}</jb-heading
              >` : A}
        ${text ? b`<p>${text}</p>` : A}
        ${buttons?.length ? b`<jb-button-panel .align=${"center"}>
                ${buttons.map((button, i2) => this._renderContactTeaserButton(button, i2))}
              </jb-button-panel>` : A}
      </div>
    `;
  }
  _renderContactTeaserButton(button, index) {
    const variant = button.variant ?? (index === 0 ? "secondary" : "primary");
    if (variant === "secondary") {
      return b`<jb-button-secondary
        .link=${button.link}
        inverted
        >${button.text}</jb-button-secondary
      >`;
    }
    if (variant === "tertiary") {
      return b`<jb-button-tertiary
        .link=${button.link}
        inverted
        >${button.text}</jb-button-tertiary
      >`;
    }
    return b`<jb-button-primary
      .link=${button.link}
      inverted
      >${button.text}</jb-button-primary
    >`;
  }
  _renderHeroImage() {
    if (this.backgroundVideoSrc) {
      return b`<jb-video
        class="background"
        .src=${this.backgroundVideoSrc}
        isBackground
      ></jb-video>`;
    }
    return b`<img
      class="background"
      src="${this.backgroundImage}"
      alt=""
    />`;
  }
  render() {
    return b`
      <section>
        <header>
          ${this._renderHeroImage()}
          <div class="content">
            ${this.headline ? b`<jb-heading
                    rank="1"
                    variant="heading-xl"
                    >${this.headline}</jb-heading
                  >` : A}
            ${this.subline ? b`<p>${this.subline}</p>` : A}
            ${this.breadcrumbs && b`
                <jb-breadcrumbs .ariaLabels=${this.breadcrumbs.ariaLabels ?? A}>
                  ${this.breadcrumbs.backlink && b`<jb-breadcrumbs-back-link
                      .link=${this.breadcrumbs.backlink.link}
                      .text=${this.breadcrumbs.backlink.text}
                      slot="backlink"
                    ></jb-breadcrumbs-back-link>`}
                  ${this.breadcrumbs.items?.map(
      (breadcrumb) => b`<jb-breadcrumbs-item
                        .link=${breadcrumb.link}
                        .text=${breadcrumb.text}
                        slot="items"
                      ></jb-breadcrumbs-item>`
    )}
                </jb-breadcrumbs>
              `}
          </div>
        </header>
        <button
          @click=${() => {
      smoothScroll(this._main);
    }}
        >
          <jb-icon iconName="material:keyboard_arrow_down"></jb-icon>
        </button>
        <main>
          <div class="content">
            ${this.video ? b`<jb-video
                    .aspect=${this.video.aspect}
                    .autoplay=${this.video.autoplay}
                    .caption=${this.video.caption}
                    .captions=${this.video.captions}
                    .clickToPlay=${this.video.clickToPlay}
                    .controls=${this.video.controls}
                    .credit=${this.video.credit}
                    .i18n=${this.video.i18n}
                    .iconPath="${this.video.iconPath}"
                    .loop=${this.video.loop}
                    .muted="${true}"
                    .poster="${this.video.poster}"
                    .preload="${this.video.preload}"
                    .src="${this.video.src}"
                    .text="${this.video.text}"
                  ></jb-video>` : A}
            <slot></slot>
            ${this._renderContactTeaser()}
          </div>
        </main>
        <svg
          class="line"
          xmlns="http://www.w3.org/2000/svg"
        >
          ${w`<path d="${this._pathString}"/>`}
        </svg>
      </section>
    `;
  }
};
JBMomentPageHero.styles = [reset_css_default, jb_moment_page_hero_css_default];
__decorateClass([
  n()
], JBMomentPageHero.prototype, "backgroundImage", 2);
__decorateClass([
  n()
], JBMomentPageHero.prototype, "backgroundMobileImage", 2);
__decorateClass([
  n()
], JBMomentPageHero.prototype, "backgroundVideoSrc", 2);
__decorateClass([
  n({ type: Object })
], JBMomentPageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n({ type: Object })
], JBMomentPageHero.prototype, "contactTeaser", 2);
__decorateClass([
  n({ reflect: true })
], JBMomentPageHero.prototype, "headline", 2);
__decorateClass([
  n()
], JBMomentPageHero.prototype, "subline", 2);
__decorateClass([
  n({ type: Object })
], JBMomentPageHero.prototype, "video", 2);
__decorateClass([
  e(".contact-teaser")
], JBMomentPageHero.prototype, "_contactTeaser", 2);
__decorateClass([
  e("header .content")
], JBMomentPageHero.prototype, "_headerContent", 2);
__decorateClass([
  e("header")
], JBMomentPageHero.prototype, "_headerElement", 2);
__decorateClass([
  e(".line")
], JBMomentPageHero.prototype, "_line", 2);
__decorateClass([
  e("main")
], JBMomentPageHero.prototype, "_main", 2);
__decorateClass([
  r()
], JBMomentPageHero.prototype, "_pathString", 2);
JBMomentPageHero = __decorateClass([
  customElement("jb-moment-page-hero")
], JBMomentPageHero);

export {
  JBMomentPageHero
};
